var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "col-lg-6 col-md-6 col-sm-12 relative-position row items-center",
        attrs: { id: "attend-left" }
      },
      [
        _vm.currentClass === null && !_vm.signupComplete
          ? _c(
              "q-card-main",
              { staticClass: "content-center col-12" },
              [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.verifyCode()
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "q-pa-md" }, [
                      _vm._v("Attend A Class")
                    ]),
                    _c(
                      "q-field",
                      { staticClass: "q-pa-md" },
                      [
                        _c("q-input", {
                          attrs: {
                            name: "",
                            autofocus: "",
                            value: _vm.classCode,
                            clearable: "",
                            placeholder: "Enter Class Code",
                            "stack-label": "Class Code",
                            before: [{ icon: "memory" }]
                          },
                          on: {
                            input: function(val) {
                              return _vm.changeVerifyCode(val)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "q-field",
                          { staticClass: "q-pa-md" },
                          [
                            _c("q-btn", {
                              attrs: {
                                label: "Validate Code",
                                color: "primary"
                              },
                              on: { click: _vm.verifyCode }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("q-field", { staticClass: "outline col-12" }, [
                  _c("span", { staticClass: "text-bold" }, [
                    _vm._v("OR LOG-IN")
                  ]),
                  _c(
                    "div",
                    { staticClass: "float-right" },
                    [
                      _c("q-btn", {
                        attrs: {
                          size: "sm",
                          label: "Login",
                          color: "secondary",
                          outline: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.goToLogin()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.currentClass !== null || _vm.signupComplete
          ? _c("class-verified")
          : _vm._e()
      ],
      1
    ),
    _c("div", {
      staticClass: "col-lg-6 col-md-6 relative-position mobile-hide",
      attrs: { id: "attend-picture" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }